export default __webpack_public_path__ + "static/media/13_photo.8093cc39.jpg";